import React from "react";
import { NavLink } from "react-router-dom";
import "./styles.scss";
import { ReactComponent as DashboardIcon } from "../../../../public/icons/NavMenu-icons/dashboard_icon.svg";
import { ReactComponent as WhatsHotIcon } from "../../../../public/icons/NavMenu-icons/whats_hot_icon.svg";
import { ReactComponent as NewsfeedIcon } from "../../../../public/icons/NavMenu-icons/newsfeed_icon.svg";
import { ReactComponent as MessageIcon } from "../../../../public/icons/NavMenu-icons/message_icon.svg";
import { ReactComponent as StarIcon } from "../../../../public/icons/NavMenu-icons/star_icon.svg";
import { ReactComponent as SashaIcon } from "../../../../public/icons/NavMenu-icons/sasha.svg";
import { useSelector } from "react-redux";
import MenuUploader from "../../shared/MenuUploader";
import MenuDivider from "../../../shared/MenuDivider";
import PodcastPromo from "../../../shared/PodcastPromo";

export default () => {
  const store = useSelector((state) => state);
  return (
    <>
      <div className="nav flex-column nav-pills hudl-navbar px-3 overflow-y-scroll flex-nowrap">
        {((store.current_user && store.current_user.user_type === "podcaster") ||
          (store.current_user && store.current_user.user_type === "artist")) && (
          <>
            <NavLink exact className="hudl-link" to={`/dashboard?type=${store.current_user.user_type}`}>
              <DashboardIcon className="mr-2" />
              Dashboard
            </NavLink>
            <NavLink exact className="hudl-link" to={`/ai-music-manager`}>
              <SashaIcon className="mr-2" />
              Sasha, Your Manager
            </NavLink>
          </>
        )}
        <NavLink exact className="hudl-link" to="/the-latest">
          <StarIcon className="mr-2" />
          The Latest
        </NavLink>
        {!!store.current_user ? (
          <NavLink exact className="hudl-link" to={`/newsfeed?type=${store.current_user.user_type}`}>
            <NewsfeedIcon className="mr-2" />
            Newsfeed
          </NavLink>
        ) : (
          <a href="/login" className="hudl-link">
            <NewsfeedIcon className="mr-2" />
            Newsfeed
          </a>
        )}
        <NavLink exact className="hudl-link" to="/browse">
          <WhatsHotIcon className="mr-2" />
          Now Charting
        </NavLink>
        {store.current_user ? (
          <NavLink exact className="hudl-link" to="/messages">
            <MessageIcon className="mr-2" />
            Messages
          </NavLink>
        ) : (
          <a href="/login" className="hudl-link">
            <MessageIcon className="mr-2" />
            Messages
          </a>
        )}
      </div>
      <MenuDivider />
      {store.current_user && store.current_user.user_type === "podcaster" && <PodcastPromo />}
      <MenuUploader user={store.current_user} />
    </>
  );
};
